<!-- impressum.component.html -->
<div class="imprint-container">
    <div class="imprint-content">
      <h1>Impressum</h1>
      <p>Stand: 09. März 2026</p>
  
      <section>
        <h2>Angaben gemäß § 5 DDG</h2>
        <p>
          Prism Corporation<br>
          Asamstr. 7a<br>
          92224 Amberg<br>
          Deutschland
        </p>
        
        <h3>Vertreten durch</h3>
        <p>
          Andreas Felber<br>
          Inhaber
        </p>
        
        <h3>Kontakt</h3>
        <p>
          E-Mail: {{ imprintEmail }}<br>
          <!-- Wenn vorhanden/optional: -->
          <!-- Website: {{ siteHost }} -->
        </p>
      </section>
  
      <section>
        <h2>Umsatzsteuer-ID</h2>
        <p>
          DE326367787
        </p>
      </section>
  
      <section>
        <h2>Redaktionell Verantwortlicher</h2>
        <p>
          Andreas Felber<br>
          Asamstr. 7a<br>
          92224 Amberg<br>
          Deutschland
        </p>
      </section>
  
      <section>
        <h2>Streitschlichtung</h2>
        <p>Hinweis zur Online-Streitbeilegung (OS): Die europäische OS-Plattform wurde zum 20.07.2025 eingestellt und ist nicht mehr verfügbar.</p>
        <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
        <p>Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
      </section>
  
      <section>
        <h2>Haftung für Inhalte</h2>
        <p>Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
        <p>Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>
      </section>
  
      <section>
        <h2>Haftung für Links</h2>
        <p>Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.</p>
        <p>Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>
      </section>
  
      <section>
        <h2>Urheberrecht</h2>
        <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.</p>
        <p>Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>
      </section>
  
      <p class="imprint-footer">
        &copy; {{currentYear}} {{ siteHost }} - Alle Rechte vorbehalten
      </p>
    </div>
  </div>

